import React, { useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from 'mdb-react-ui-kit';


const ReturnPolicy = ({setActive3}) => {

  const [active, setActive] = useState(true);

  const closeReturnPolicy = () => {
    setActive(!active);
  }

  return (
    <>
      <MDBModal staticBackdrop show={active} setShow={setActive3}>
        <MDBModalDialog>
          <MDBModalContent className='text-dark'>
            <MDBModalHeader>
              <MDBModalTitle>Return and Refund Policy</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={closeReturnPolicy}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <p>Last updated: May 16, 2022</p>
              <p>Thank you for shopping at Societal-Labs.</p>
              <p>If, for any reason, You are not completely satisfied with a purchase We invite You to review our policy on refunds and returns.</p>
              <p>The following terms are applicable for any products that You purchased with Us.</p>
              <h1>Interpretation and Definitions</h1>
              <h2>Interpretation</h2>
              <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
              <h2>Definitions</h2>
              <p>For the purposes of this Return and Refund Policy:</p>
              <ul>
              <li>
              <p><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Societal-Labs, 201 West Big Beaver Rd. Ste 2020-r, Troy, MI, 48084.</p>
              </li>
              <li>
              <p><strong>Goods</strong> refer to the items offered for sale on the Service.</p>
              </li>
              <li>
              <p><strong>Orders</strong> mean a request by You to purchase Goods from Us.</p>
              </li>
              <li>
              <p><strong>Service</strong> refers to the Website.</p>
              </li>
              <li>
              <p><strong>Website</strong> refers to Societal-Labs, accessible from <a href="www.societal-labs.com" rel="external nofollow noopener" target="_blank">www.societal-labs.com</a></p>
              </li>
              <li>
              <p><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p>
              </li>
              </ul>
              <h1>Your Order Cancellation Rights</h1>
              <p>You are entitled to cancel Your Order within 48 hours without giving any reason for doing so.</p>
              <p>The deadline for cancelling an Order is 48 hours from the date & time on which You received the Goods or on which a third party you have appointed, who is not the carrier, takes possession of the product delivered.</p>
              <p>In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear statement. You can inform us of your decision by:</p>
              <ul>
              <li>
              <p>By email: support@societal-labs.com</p>
              </li>
              <li>
              <p>By visiting the contact section on our website: <a href="#contact" rel="external nofollow noopener" target="_blank">www.societal-labs.com</a></p>
              </li>
              </ul>
              <p>We will reimburse You no later than 7 days from the day on which We receive the returned Goods. We will use the same means of payment as You used for the Order, and You will not incur any fees for such reimbursement.</p>
              <h1>Conditions for Returns</h1>
              <p>In order for the Goods to be eligible for a return, please make sure that:</p>
              <ul>
              <li>The Goods were purchased in the last 48 hours</li>
              <li>You can provide a Proof of Purchase receipt and verify ownership</li>
              </ul>
              <p>We reserve the right to refuse returns of any merchandise that does not meet the above return conditions in our sole discretion.</p>
              <h1>Returning Goods</h1>
              <p>You are responsible for the cost and risk of returning the Goods to Us. You should send the Goods to the following address:0.0.725866</p>
              <p>Please send an email in the Contact Us section of our website, or email EMAIL HERE</p>
              <h2>Contact Us</h2>
              <p>If you have any questions about our Returns and Refunds Policy, please contact us:</p>
              <ul>
              <li>
              <p>By email: support@societal-labs.com</p>
              </li>
              <li>
              <p>By visiting the Contact Us section on our website: <a href="#contact" rel="external nofollow noopener" target="_blank">www.societal-labs.com</a></p>
              </li>
              </ul>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

    </>
  )
}

export default ReturnPolicy;